import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
// import { getUTCToLocalTimeZone, toLocaleDateTimeString } from 'helpers/dateHelper';
// import { IconFault, IconWarningType } from '../../../../../Icons/MotionPortalIcons';
import './style.scss';
import { formatDate, formatDateTime } from 'helpers/dateTimeFormatter';

const CoolingAnomalyTooltip = ({
    timeStamp,
    uom,
    mean,
    min,
    max,
    // faultCount,
    // warningCount,
    title,
}) => {
    return (
        <div className='custom-cooling-anomaly-tooltip' id='cooling-anomaly-tooltip'>
            <div className='t-header' id='cooling-anomaly-tooltip-header'>
                {title || translate('ABB.Powertrain.Frontend.dcVoltageLabel')}
                <span className='t-date'>
                    {timeStamp ? formatDateTime(timeStamp) : formatDate(timeStamp)}
                </span>
            </div>
            <div className='t-item t-group' id='cooling-anomaly-tooltip-values'>
                <div className='t-subitem'>
                    <span className='t-label'>{translate('ABB.Powertrain.Frontend.meanLabel')} :</span>
                    <span className='t-value'>{mean ?? '-'}{uom ? ` ${uom}` : ''}</span>
                </div>
                <div className='t-subitem'>
                    <span className='t-label'>{translate('ABB.Powertrain.Frontend.rangeLabel')} : </span>
                    <span className='t-value'>{min ?? '-'} / {max ?? '-'}</span>
                </div>
            </div>
            {/* The related faults and warnings are currently not available for cooling anomaly, so these sections are hidden for now. They can be easily added back when the data becomes available */}
            {/* <div className='t-item' id='cooling-anomaly-tooltip-faults'>
                <IconFault className='t-icon' />
                <span className='t-label'>{translate('ABB.Powertrain.Frontend.relatedFaultsLabel')} : </span>
                <span className='t-value'>{faultCount ?? 0}</span>
            </div>
            <div className='t-item' id='cooling-anomaly-tooltip-warnings'>
                <IconWarningType className='t-icon' />
                <span className='t-label'>{translate('ABB.Powertrain.Frontend.relatedWarningsLabel')} : </span>
                <span className='t-value'>{warningCount ?? 0}</span>
            </div> */}
        </div>
    );
};

CoolingAnomalyTooltip.propTypes = {
    timeStamp: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date)
    ]),
    value: PropTypes.shape({
        color: PropTypes.string,
        label: PropTypes.string,
    }),
    isUTC: PropTypes.bool,
    mean: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    faultCount: PropTypes.number,
    warningCount: PropTypes.number,
    faultLabel: PropTypes.string,
    warningLabel: PropTypes.string,
    title: PropTypes.string
};

export default CoolingAnomalyTooltip;
